<template>
  <div id="pageRoot">
    <p class="textBase appearAnimationB" id="text01" style="z-index: 6">
      Escribe el nombre de cada producto en el cuadro que corresponde.
    </p>

    <div
      class="text-box-a pageElement hover-animation-a"
      id="textBox01"
      style="
        z-index: 3;
        background-image: url(/pages/img/sordo/svgPage75TextBox01.svg);
        background-size: cover;
      "
    >
      <p class="textBase" id="textBox01Text">¡Ya prendí el fuego!</p>
    </div>
    <div
      class="text-box-a pageElement hover-animation-a"
      id="textBox02"
      style="
        z-index: 3;
        background-image: url(/pages/img/sordo/svgPage75TextBox02.svg);
      "
    >
      <p class="textBase" id="textBox02Text">¡Me encanta el pan calentito!</p>
    </div>

    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="1"
      id="inputField01"
      class="pageElement"
      style="z-index: 7"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="2"
      id="inputField02"
      class="pageElement"
      style="z-index: 7"
    />
    <saved-input
      v-bind:page="$parent.page"
      v-bind:type="$parent.type"
      number="3"
      id="inputField03"
      class="pageElement"
      style="z-index: 7"
    />

    <!-- TEXTS ----------------------------------------------------------------------------------------------------->
    <!-- TEXTS ----------------------------------------------------------------------------------------------------->
    <div
      class="basicItem01"
      id="tagAsado"
      style="
        z-index: 3;
        background-image: url(/pages/img/sordo/svgPage75TagShorter.svg);
        background-size: cover;
      "
    >
      <p class="textBase tagText">asado</p>
    </div>
    <div
      class="basicItem01"
      id="tagPan"
      style="
        z-index: 3;
        background-image: url(/pages/img/sordo/svgPage75TagShorter.svg);
        background-size: cover;
      "
    >
      <p class="textBase tagText">pan</p>
    </div>
    <div
      class="basicItem01"
      id="tagCuritas"
      style="
        z-index: 3;
        background-image: url(/pages/img/sordo/svgPage75TagShorter.svg);
        background-size: cover;
      "
    >
      <p class="textBase tagText">curitas</p>
    </div>
    <div
      class="basicItem01"
      id="tagPelota"
      style="
        z-index: 3;
        background-image: url(/pages/img/sordo/svgPage75TagShorter.svg);
        background-size: cover;
      "
    >
      <p class="textBase tagText">pelota</p>
    </div>
    <div
      class="basicItem01"
      id="tagAlgodon"
      style="
        z-index: 3;
        background-image: url(/pages/img/sordo/svgPage71TagShort.svg);
        background-size: cover;
      "
    >
      <p class="textBase tagText">algodón</p>
    </div>
    <div
      class="basicItem01"
      id="tagRompecabezas"
      style="
        z-index: 3;
        background-image: url(/pages/img/sordo/svgPage75TagMedium.svg);
        background-size: cover;
      "
    >
      <p class="textBase tagText">rompecabezas</p>
    </div>
    <div
      class="basicItem01"
      id="tagChorizo"
      style="
        z-index: 3;
        background-image: url(/pages/img/sordo/svgPage71TagShort.svg);
        background-size: cover;
      "
    >
      <p class="textBase tagText">
        <span id="linethrough">chorizo</span>
      </p>
    </div>
    <div
      class="basicItem01"
      id="tagGalleta"
      style="
        z-index: 3;
        background-image: url(/pages/img/sordo/svgPage75TagShorter.svg);
        background-size: cover;
      "
    >
      <p class="textBase tagText">galleta</p>
    </div>

    <p class="textBase" id="text02">CARNICERÍA</p>
    <p class="textBase" id="text03">PANADERÍA</p>

    <p class="textBase" id="text04">CHORIZO</p>

    <!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
    <div class="pageSVG">
      <img
        src="/pages/img/sordo/svgPage75Background.svg"
        class="pageElement"
        style="width: 100%; height: auto"
      />
    </div>

    <!-- FONDO SVG ----------------------------------------------------------------------------------------------------->
  </div>
</template>
<style scoped>
.textBase {
  margin: 0px;
  z-index: 3;
  font-family: Open Sans, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 33px;
  color: #000000;
}
.tagText {
  position: absolute;
  left: 0px;
  right: 0px;
  top: 5px;
  bottom: 0px;

  font-size: 36px;
  line-height: 49px;
  text-align: center;

  color: #fefafa;
}

#inputField01 {
  position: absolute;
  width: 329px;
  left: 95px;
  top: 630px;
  height: 46px;

  font-size: 32px;
}
#inputField02 {
  position: absolute;
  width: 329px;
  height: 46px;
  left: 586px;
  top: 540px;

  font-size: 32px;
}
#inputField03 {
  position: absolute;
  width: 329px;
  height: 46px;
  left: 586px;
  top: 630px;
  font-size: 32px;
}
#text01 {
  position: absolute;
  width: 766px;
  height: 35px;
  left: 88px;
  top: 63px;

  font-style: normal;
  font-weight: normal;
  font-size: 24px;
  line-height: 25px;
}
#text02 {
  position: absolute;
  width: 216.98px;
  height: 63.56px;
  left: 208px;
  top: 450px;

  font-size: 33px;
  line-height: 45px;
  text-align: center;

  color: #fffcfc;

  transform: rotate(-1.45deg);
}
#text03 {
  position: absolute;
  width: 216.98px;
  height: 63.56px;
  left: 595.5px;
  top: 457.55px;

  font-size: 33px;
  line-height: 45px;
  text-align: center;

  color: #fffcfc;

  transform: rotate(0.47deg);
}
#text04 {
  position: absolute;
  width: 216.98px;
  height: 63.56px;
  left: 165px;
  top: 550px;

  font-size: 33px;
  line-height: 45px;
  text-align: center;

  color: #2bb673;
}

#textBox01 {
  position: absolute;
  width: 387.15px;
  height: 115px;
  left: 8px;
  top: 324px;
}
#textBox01Text {
  position: absolute;
  left: 8.82%;
  right: 0%;
  top: 15.34%;
  bottom: 41.18%;

  font-size: 36px;
  line-height: 40px;

  color: #fbf8f8;
}

#textBox02 {
  position: absolute;
  width: 525.43px;
  height: 134.4px;
  left: 490px;
  top: 318px;
}
#textBox02Text {
  position: absolute;
  width: 495px;
  height: 46.27px;
  left: 17.52px;
  top: 24.45px;

  font-size: 36px;
  line-height: 40px;
  /* or 111% */

  color: #fbf8f8;

  transform: rotate(0.92deg);
}

#tagAsado {
  position: absolute;
  width: 148px;
  height: 70.55px;
  left: 57px;
  top: 129px;
}
#tagPan {
  position: absolute;
  width: 117px;
  height: 70.55px;
  left: 259px;
  top: 129px;
}
#tagCuritas {
  position: absolute;
  width: 156px;
  height: 70.55px;
  left: 412px;
  top: 131px;
}
#tagPelota {
  position: absolute;
  width: 156px;
  height: 70.55px;
  left: 610px;
  top: 136px;
}
#tagAlgodon {
  position: absolute;
  width: 202px;
  height: 70.55px;
  left: 808px;
  top: 131px;
}
#tagRompecabezas {
  position: absolute;
  width: 305px;
  height: 70.55px;
  left: 98px;
  top: 218px;
}
#tagChorizo {
  position: absolute;
  width: 174px;
  height: 70.55px;
  left: 467px;
  top: 220px;
}
#tagGalleta {
  position: absolute;
  width: 156px;
  height: 70.55px;
  left: 681px;
  top: 222px;
}

#linethrough {
  text-decoration: line-through;
}
</style>
<script>
export default {
  data() {
    return {
      videos: [
        "p75-76/V58.mp4",
        "p75-76/V59.mp4",
        "p75-76/V60.mp4",
        "p75-76/V61.mp4",
        "p75-76/V62.mp4",
        "p75-76/V63.mp4",
        "p75-76/V64.mp4",
        "p75-76/V65.mp4",
        "p75-76/V66.mp4",
        "p75/V67.mp4",
        "p75/V68.mp4",
      ],
    };
  },
};
</script>